import {
        FETCH_UNIVERSEMEMBERS_BEGIN,
        FETCH_UNIVERSEMEMBERS_SUCCESS,
        FETCH_UNIVERSEMEMBERS_FAILURE
    } from '../constants/universeList'
import { getSelectedUniverseDetails, getUniverseMembers } from '../../config/apiConfig';
import { sbaAxios } from '../utils/sbaAxios';
import { updateEntity } from '../CommonAPI';
export const getUniverseMembersAction = (universeID, universeDetails) => {
  return (dispatch) => {
    dispatch(fetchUniverseListsBegin());
    sbaAxios({ url: `${getUniverseMembers}${universeID}?isEntityMasterId=false`, method: 'get' })
      .then((repos) => {
        if (!universeDetails?.UniverseId!==universeID) {
          sbaAxios({ url: `${getSelectedUniverseDetails}${universeID}`, method: 'get' })
            .then((repo) => {
              universeDetails = repo[0];
              dispatch(fetchUniverseListSuccess({ ...universeDetails, UniverseMemberDetails: repos }));
            })
            .catch((error) => {
              console.error('Error fetching universe details:', error);
            });
        }
        else{
          dispatch(fetchUniverseListSuccess({ ...universeDetails, UniverseMemberDetails: repos }));
        }
        updateEntity("UniverseId",universeID);
        return repos;
      })
      .catch((error) => {
        return dispatch(fetchUniverseListFailure(error));
      });
  };
};
export const fetchUniverseListsBegin = () => ({
    type: FETCH_UNIVERSEMEMBERS_BEGIN,
  });
  
  export const fetchUniverseListSuccess = (universe) => ({
    type: FETCH_UNIVERSEMEMBERS_SUCCESS,
    payload: {universe},
  });
  
  
  export const fetchUniverseListFailure = (errorMessage) => ({
    type: FETCH_UNIVERSEMEMBERS_FAILURE,
    payload: {errorMessage}
  });
  